import styled from '@emotion/styled'
import { mq } from '../../helpers'
import { gsColors } from '../../styles/Variables'

export const FAQWrapper = styled.div`
  width: 100%;
  padding: 80px 0;
  display: flex;
  max-width: 1600px;
  flex-direction: column;
  align-items: ${props => props.align ? props.align : 'center'};
  background-color: ${gsColors.khaki};

  .faq-container{
    width: 100%;
    max-width: 90%;
    /* padding-left: 88px; */
    /* padding-right: 88px; */
    padding-top: 48px;
    padding-bottom: 70px;
    display: flex;
    flex-direction: column;
    gap: 30px;

    .faq-item {
      border-left: 1px solid black;
      padding-left: 5%;
      .faq-title-container {
        display: flex;
        .faq-carrot {
          width: 1px;
          height: 32px;
          background-color: black;
          margin-right: 5%;
        }
      }
    }

  }

  ${mq('max', '768px')} {
    padding: 41px 0 50px 0;
    max-width: '90%';
  }

  .faq-title {
    display: flex;
    align-items: center;
    text-align: left;
    &:hover {
        cursor: pointer;
    }
  }

  .faq-body {
    text-align: left;
    color: ${gsColors.saltBox};
    height: max-content;
    max-height: 0px;
    overflow: hidden;
    transition: all .3s ease-in-out;
    // margin-left: 5%;
    padding-top: 10px;
  }


  .faq-open {
    max-height: 500px;
  }
`
